import moment from 'moment-timezone';
import { UTC_TIMEZONE } from './constants';
export const getDefaultTimezone = () => {
    if (!Intl) {
        return UTC_TIMEZONE;
    }
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
export const normalizeTimezone = (timezone) => {
    if (!timezone) {
        return undefined;
    }
    if (timezone.toUpperCase() === UTC_TIMEZONE) {
        return UTC_TIMEZONE;
    }
    return timezone;
};
export const isValidTimezone = (timezone) => {
    return moment.tz.zone(timezone) !== null;
};
export const getTimezoneOffset = (timezone) => {
    return moment.tz(timezone).utcOffset();
};
//# sourceMappingURL=timezone.js.map